import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 -960 960 960"

const AddIcon = createSvgIcon(
  <>
    <path d='M444-444H240v-72h204v-204h72v204h204v72H516v204h-72v-204Z' />
  </>,
  'AddIcon'
)

export default AddIcon
